import UrlGeneration from "../libs/UrlGeneration";
export default new (class {
    constructor() {
        this.wrapClass = 'product-filter'
        this.preloaderClass = 'product-filter_preloader';
        document.addEventListener('DOMContentLoaded', () => this.init())
    }

    init() {
        document.body.addEventListener('change', (e) => {
            if (e.target.name == 'offer') {
                const wrap = e.target.closest(`.${this.wrapClass}`);
                wrap.classList.add(this.preloaderClass)
                UrlGeneration.replace('offer', e.target.value);
                UrlGeneration.update('offer', e.target.value);
                const _this = this;
                oc.ajax(wrap.dataset.handler, {
                    complete: function() {
                        wrap.classList.remove(_this.preloaderClass);
                    },
                    update: {
                        'product-page/product-gallery': '#product-gallery',
                        'product-page/product-name': '#product-name',
                    }
                });
            }
        })
    }
})();
